module.exports = __webpack_public_path__ + "static/media/close.a372c15c.svg";